/*
主体签约页面的目录栏标题与子项
 */
import { i18n, getBDCountry } from '@/common/utils/i18n'
import VueI8n from '@/i18n/locale'

const country = getBDCountry() || 'MX'
const { gettext } = i18n

const partyInfo = {
  title: gettext('基础信息'),
  category: 'basic',
  group: [
    {
      title: VueI8n.t('Gattaran_transformation__PgJQ'),
      name: 'partyInfo',
      dataPath: 'signForm.basic'
    }
  ]
}

const relatedInfo = {
  title: VueI8n.t('FoodB_management_Store_association_coYB'),
  category: 'relationShop',
  group: [
    {
      title: VueI8n.t('FoodB_management_Store_association_coYB'),
      name: 'relationShop',
      // dataPath: 'signForm.basic'
    }
  ]
}
const baseConfigOfMX = [
  partyInfo,
  {
    title: gettext('资质信息'),
    category: 'qualification',
    group: [
      {
        title: gettext('公司公证'),
        name: 'companyInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('合同信息'),
    category: 'contract',
    group: [
      {
        title: gettext('法人信息'),
        name: 'legalInfo'
      },
      {
        title: gettext('合同信息'),
        name: 'contractInfo'
      },
      {
        title: gettext('结算信息'),
        name: 'accountInfo'
      },
      {
        title: gettext('纳税信息'),
        name: 'taxInfo',
        dataPath: 'signForm.corp'
      },
      {
        title: gettext('启动费'),
        name: 'startupMoney',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('设备信息'),
        name: 'equipmentInfo',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('签字授权书'),
        name: 'signAuthInfo',
        tips: true
      },
      {
        title: gettext('打款授权书'),
        name: 'payAuthInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('其他信息'),
    category: 'other',
    group: [
      {
        title: gettext('审批邮件'),
        name: 'emailInfo',
        tips: true
      },
      {
        title: gettext('银行流水单'),
        name: 'bankInfo',
        tips: true
      },
      {
        title: gettext('其他'),
        name: 'othersInfo',
        tips: true
      }
    ]
  },
  relatedInfo
]

const baseConfigOfBR = [
  partyInfo,
  {
    title: gettext('资质信息'),
    category: 'qualification',
    group: [
      {
        title: gettext('CNPJ'),
        name: 'cnpjInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('合同信息'),
    category: 'contract',
    group: [
      {
        title: gettext('法人信息'),
        name: 'legalInfo'
      },
      {
        title: gettext('合同信息'),
        name: 'contractInfo'
      },
      {
        title: gettext('结算信息'),
        name: 'accountInfo'
      },
      {
        title: gettext('纳税信息'),
        name: 'taxInfo',
        dataPath: 'signForm.corp'
      },
      {
        title: gettext('启动费'),
        name: 'startupMoney',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('设备信息'),
        name: 'equipmentInfo',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('签字授权书'),
        name: 'signAuthInfo',
        tips: true
      },
      {
        title: gettext('打款授权书'),
        name: 'payAuthInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('其他信息'),
    category: 'other',
    group: [
      {
        title: gettext('审批邮件'),
        name: 'emailInfo',
        tips: true
      },
      {
        title: gettext('银行流水单'),
        name: 'bankInfo',
        tips: true
      },
      {
        title: gettext('其他'),
        name: 'othersInfo',
        tips: true
      }
    ]
  },
  relatedInfo
]

const baseConfigOfPE = [
  partyInfo,
  {
    title: gettext('资质信息'),
    category: 'qualification',
    group: [{
      title: VueI8n.t('FoodB_CL_power_of_KgHH' /** 委托书 */),
      name: 'proxyInfo',
      tips: false
    }]
  },
  {
    title: gettext('合同信息'),
    category: 'contract',
    group: [
      {
        title: gettext('法人信息'),
        name: 'legalInfo'
      },
      {
        title: gettext('合同信息'),
        name: 'contractInfo'
      },
      {
        title: gettext('结算信息'),
        name: 'accountInfo'
      },
      {
        title: gettext('纳税信息'),
        name: 'taxInfo',
        dataPath: 'signForm.corp'
      },
      {
        title: gettext('启动费'),
        name: 'startupMoney',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('设备信息'),
        name: 'equipmentInfo',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('签字授权书'),
        name: 'signAuthInfo',
        tips: true
      },
      {
        title: gettext('打款授权书'),
        name: 'payAuthInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('其他信息'),
    category: 'other',
    group: [
      {
        title: gettext('审批邮件'),
        name: 'emailInfo',
        tips: true
      },
      {
        title: gettext('银行流水单'),
        name: 'bankInfo',
        tips: true
      },
      {
        title: gettext('其他'),
        name: 'othersInfo',
        tips: true
      }
    ]
  },
  relatedInfo
]
const baseConfigOfDO = [
  partyInfo,
  {
    title: gettext('资质信息'),
    category: 'qualification',
    group: [{
      title: gettext('公司公证'),
      name: 'companyInfo',
      tips: true
    }]
  },
  {
    title: gettext('合同信息'),
    category: 'contract',
    group: [
      {
        title: gettext('法人信息'),
        name: 'legalInfo'
      },
      {
        title: gettext('合同信息'),
        name: 'contractInfo'
      },
      {
        title: gettext('结算信息'),
        name: 'accountInfo'
      },
      {
        title: gettext('纳税信息'),
        name: 'taxInfo',
        dataPath: 'signForm.corp'
      },
      {
        title: gettext('启动费'),
        name: 'startupMoney',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('设备信息'),
        name: 'equipmentInfo',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('签字授权书'),
        name: 'signAuthInfo',
        tips: true
      },
      {
        title: gettext('打款授权书'),
        name: 'payAuthInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('其他信息'),
    category: 'other',
    group: [
      {
        title: gettext('审批邮件'),
        name: 'emailInfo',
        tips: true
      },
      {
        title: gettext('银行流水单'),
        name: 'bankInfo',
        tips: true
      },
      {
        title: gettext('其他'),
        name: 'othersInfo',
        tips: true
      }
    ]
  },
  relatedInfo
]
const baseConfigOfCL = [
  partyInfo,
  {
    title: gettext('资质信息'),
    category: 'qualification',
    group: [{
      title: gettext('公司公证'),
      name: 'companyInfo',
      tips: true
    },
    {
      title: gettext('市政经营许可证'),
      name: 'cityInfo',
      tips: true
    },
    {
      title: gettext('卫生安全通知'),
      name: 'healthInfo',
      tips: true
    },
    {
      title: gettext('土地使用许可证'),
      name: 'landInfo',
      tips: true
    },
    {
      title: VueI8n.t('FoodB_CL_power_of_KgHH' /** 委托书 */),
      name: 'proxyInfo',
      tips: false
    }
    ]
  },
  {
    title: gettext('合同信息'),
    category: 'contract',
    group: [
      {
        title: gettext('法人信息'),
        name: 'legalInfo'
      },
      {
        title: gettext('合同信息'),
        name: 'contractInfo'
      },
      {
        title: gettext('结算信息'),
        name: 'accountInfo'
      },
      {
        title: gettext('纳税信息'),
        name: 'taxInfo',
        dataPath: 'signForm.corp'
      },
      {
        title: gettext('启动费'),
        name: 'startupMoney',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('设备信息'),
        name: 'equipmentInfo',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('签字授权书'),
        name: 'signAuthInfo',
        tips: true
      },
      {
        title: gettext('打款授权书'),
        name: 'payAuthInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('其他信息'),
    category: 'other',
    group: [
      {
        title: gettext('审批邮件'),
        name: 'emailInfo',
        tips: true
      },
      {
        title: gettext('银行流水单'),
        name: 'bankInfo',
        tips: true
      },
      {
        title: gettext('其他'),
        name: 'othersInfo',
        tips: true
      }
    ]
  },
  relatedInfo
]
const baseConfigOfCO = [
  partyInfo,
  {
    title: gettext('资质信息'),
    category: 'qualification',
    group: [{
      title: gettext('公司公证'),
      name: 'companyInfo',
      tips: true
    }
    ]
  },
  {
    title: gettext('合同信息'),
    category: 'contract',
    group: [
      {
        title: gettext('法人信息'),
        name: 'legalInfo'
      },
      {
        title: gettext('合同信息'),
        name: 'contractInfo'
      },
      {
        title: gettext('结算信息'),
        name: 'accountInfo'
      },
      {
        title: gettext('纳税信息'),
        name: 'taxInfo',
        dataPath: 'signForm.corp'
      },
      {
        title: gettext('启动费'),
        name: 'startupMoney',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('设备信息'),
        name: 'equipmentInfo',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('签字授权书'),
        name: 'signAuthInfo',
        tips: true
      },
      {
        title: gettext('打款授权书'),
        name: 'payAuthInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('其他信息'),
    category: 'other',
    group: [
      {
        title: gettext('审批邮件'),
        name: 'emailInfo',
        tips: true
      },
      {
        title: gettext('银行流水单'),
        name: 'bankInfo',
        tips: true
      },
      {
        title: gettext('其他'),
        name: 'othersInfo',
        tips: true
      }
    ]
  },
  relatedInfo
]
const baseConfigOfCR = [
  partyInfo,
  {
    title: gettext('资质信息'),
    category: 'qualification',
    group: [{
      title: gettext('公司公证'),
      name: 'companyInfo',
      tips: true
    }]
  },
  {
    title: gettext('合同信息'),
    category: 'contract',
    group: [
      {
        title: gettext('法人信息'),
        name: 'legalInfo'
      },
      {
        title: gettext('合同信息'),
        name: 'contractInfo'
      },
      {
        title: gettext('结算信息'),
        name: 'accountInfo'
      },
      {
        title: gettext('纳税信息'),
        name: 'taxInfo',
        dataPath: 'signForm.corp'
      },
      {
        title: gettext('启动费'),
        name: 'startupMoney',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('设备信息'),
        name: 'equipmentInfo',
        // 该方法， 是合同2.0需求新增字段。用来审核 此项， 是否展示在合同表单中。其中合同1.0版本，是不需要展示这一项的。2.0则需要。
        audit: function (contractVersion) {
          return contractVersion === '2.0'
        }
      },
      {
        title: gettext('签字授权书'),
        name: 'signAuthInfo',
        tips: true
      },
      {
        title: gettext('打款授权书'),
        name: 'payAuthInfo',
        tips: true
      }
    ]
  },
  {
    title: gettext('其他信息'),
    category: 'other',
    group: [
      {
        title: gettext('审批邮件'),
        name: 'emailInfo',
        tips: true
      },
      {
        title: gettext('银行流水单'),
        name: 'bankInfo',
        tips: true
      },
      {
        title: gettext('其他'),
        name: 'othersInfo',
        tips: true
      }
    ]
  },
  relatedInfo
]

const baseConfig = {
  'PE': baseConfigOfPE,
  'MX': baseConfigOfMX,
  'BR': baseConfigOfBR,
  'DO': baseConfigOfDO,
  'CL': baseConfigOfCL,
  'CO': baseConfigOfCO,
  'CR': baseConfigOfCR

}
export default baseConfig[country]
